import React from 'react';
import type { GroupedExperiences } from '@axiom/validation';

import { TalentExperiencesGroup } from './TalentExperiencesGroup';

export type TalentExperiencesProps = {
  groupedExperiences: GroupedExperiences[];
  name?: string;
};

export const TalentExperiences = ({
  groupedExperiences,
}: TalentExperiencesProps) => {
  return (
    <>
      {groupedExperiences.map(group => (
        <TalentExperiencesGroup
          key={`experience-group-${group.experiences[0]?.id}`}
          groupedExperiences={group}
        />
      ))}
    </>
  );
};
